import * as mdi from '@mdi/js'

/** Default tile matches mobile `DEFAULT_SCENARIO_ICON`. */
export const DEFAULT_TRAINING_ICON_NAME = 'fire-truck'
export const DEFAULT_TRAINING_ICON_BACKGROUND = '#fdecea'
export const DEFAULT_TRAINING_ICON_COLOR = '#c0392b'

/** `fire-truck` → `mdiFireTruck` (@mdi/js export). */
export function mdiPathFromIconName(name: string | null | undefined): string {
  const raw = name?.trim() || DEFAULT_TRAINING_ICON_NAME
  const parts = raw.split(/[-_]/).filter(Boolean)
  if (!parts.length) return mdi.mdiFireTruck
  const camel = parts
    .map((p, i) => (i === 0 ? p.toLowerCase() : p.charAt(0).toUpperCase() + p.slice(1).toLowerCase()))
    .join('')
  const key = `mdi${camel.charAt(0).toUpperCase()}${camel.slice(1)}`
  const path = (mdi as Record<string, string>)[key]
  return typeof path === 'string' && path.length > 0 ? path : mdi.mdiFireTruck
}
